var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconZeroYen = function SvgIconZeroYen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 17.147C34 6.02 39.023.5 51 .5c12.074 0 17 5.607 17 16.647v30.706C68 58.807 63.074 64.5 51 64.5c-12.364 0-17-5.865-17-16.647V17.147Zm17-8.194c-3.477 0-5.602 1.984-5.602 5.693v35.709c0 3.622 2.028 5.692 5.602 5.692 3.67 0 5.602-2.07 5.602-5.692v-35.71c0-3.536-1.835-5.692-5.602-5.692ZM15.162 50.995V59.5H9.743v-8.505H1.236v-2.982h8.507V44.64H1.236v-3.031h7.177L0 24.5h5.703l3.708 8.75c.394.947.782 1.903 1.173 2.868a231.608 231.608 0 0 0 1.869 4.513h.19c.43-1.022.84-2.013 1.241-2.986a233.521 233.521 0 0 1 1.848-4.395l3.707-8.75H25L16.445 41.61h7.32v3.03h-8.603v3.374h8.602v2.982h-8.602Z",
    fill: "#111"
  })));
};
export default SvgIconZeroYen;